import { Divider, FormControl, RadioGroup, Stack, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ItemOptionGroupDto from "../../../models/ItemOptionGroupDto";
import Option from "./Option"
import { Controller } from "react-hook-form";
import { useCallback } from "react";
import { SelectedItemOptions } from "../../dialogs/itemOptionsDialog/ItemOptionsDialog";

interface OptionsProps {
    optionGroups: ItemOptionGroupDto[];
    displayOnly?: boolean;
    selectedOptions?: SelectedItemOptions;
}

export interface OptionsForm {
    id: number;
}

export default function Options({ optionGroups, displayOnly = false, selectedOptions }: OptionsProps) {
    const { t } = useTranslation();

    const displayedOptions = useCallback((optionGroup: ItemOptionGroupDto, displayOnly = false) => {
        return (
            <>
                <Typography sx={{ fontWeight: 'bold' }} variant="h6">{optionGroup.value.value}</Typography>
                {!displayOnly && <Typography variant="subtitle1">{t("dialogChooseOption")}</Typography>}
                <Divider variant="fullWidth" sx={{ mb: '0.8rem', bgcolor: 'darkgrey' }} />
                {
                    optionGroup.itemOptions.sort((a, b) => a.price === 0 ? -1 : 0).map(option => {
                        return (
                            <Option key={option.id} option={option} displayOnly={displayOnly} />
                        );
                    })
                }
            </>
        );
    }, [t]);

    return (
        <Stack>
            {optionGroups.map((optionGroup) => {
                return (
                    <FormControl key={optionGroup.id}>
                        {displayOnly ?
                            <>
                                {displayedOptions(optionGroup, displayOnly)}
                            </> :
                            <Controller
                                name={'options.' + optionGroup.id}
                                defaultValue={selectedOptions ? selectedOptions.itemOptionGroups.filter(itemOptionGroup => itemOptionGroup.id === optionGroup.id)[0].itemOptions[0].id : optionGroup.itemOptions[0]?.id}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <RadioGroup
                                            aria-labelledby={"radio-buttons-option-group-label-" + optionGroup.id}
                                            defaultValue={optionGroup.itemOptions[0]?.id}
                                            name="radio-buttons-group"
                                            value={value}
                                            onChange={onChange}
                                        >
                                            {displayedOptions(optionGroup, displayOnly)}
                                        </RadioGroup>
                                    );
                                }} />
                        }
                    </FormControl>
                );
            })}
        </Stack>
    );
}